export default __webpack_public_path__ + "static/media/EasySimpleIcon.f745b3b0.svg";